export default function Quote() {
  return (
    <figure data-aos="fade-up" className="w-100 mt-5 text-center">
      <blockquote className="blockquote">
        <p>Achieving goals is about investing time in improving yourself!</p>
      </blockquote>
      <figcaption className="blockquote-footer">
        Unknown <cite title="Source Title">author</cite>
      </figcaption>
    </figure>
  )
}